import { put, takeLatest } from 'redux-saga/effects';

import { types as offerTypes, ActionCreators as OfferActionCreators } from '@occc-app/Offer/redux';
import { safeAsync } from '@occc-app/lib/safeAsync';

import actions from './actions';
import { deserializeOffer } from './deserializers';

function* deserializeOfferMetaData(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  const metaData = deserializeOffer(action.offerAttributes);
  yield put(actions.requestMetaDataOK(metaData));
}

const sagas = {
  deserializeOfferMetaData: safeAsync(deserializeOfferMetaData),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.deserializeOfferMetaData);
}
